<template>
  <el-table
      :data="dataPropertyProfiles"
      :class="{'hide-empty-text': loading}"
      border>
    <slot name="head"></slot>

    <el-table-column
        label="追番"
        prop="index"
        width="70"
        align="center">
    </el-table-column>
    <el-table-column
        label="名称"
        prop="name">
      <template #default="{row}">
        <table-inline>
          <text-field-like
              :value="row.name"
              :placeholder="row.nameAlt">
          </text-field-like>
        </table-inline>
      </template>
    </el-table-column>
    <el-table-column
        label="説明"
        prop="description">
      <template #default="{row}">
        <table-inline>
          <text-field-like
              :value="row.description"
              placeholder="未設定"
              multi-line>
          </text-field-like>
        </table-inline>
      </template>
    </el-table-column>
    <el-table-column
        label="データ型"
        align="center"
        prop="dataType"
        width="120">
      <template #default="{row}">
        {{ dataTypes[row.dataType] }}
      </template>
    </el-table-column>

    <el-table-column
        label="主キー"
        prop="isPrimaryKey"
        width="70"
        align="center">
      <template #default="{row}">
        <table-inline>
          <readonly-checkbox :value="row.isPrimaryKey"></readonly-checkbox>
        </table-inline>
      </template>
    </el-table-column>

    <el-table-column
        label="必須"
        prop="isRequired"
        width="70"
        align="center">
      <template #default="{row}">
        <table-inline>
          <readonly-checkbox :value="row.isRequired"></readonly-checkbox>
        </table-inline>
      </template>
    </el-table-column>

    <slot name="tail"></slot>

    <template #append>
      <v-row
          justify="center"
          class="pa-10"
          v-if="loading">
        <v-progress-circular indeterminate/>
      </v-row>
    </template>
  </el-table>
</template>

<script>
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import {DATA_PROPERTY_DEFINITION_DATA_TYPES} from "@/constants";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";

export default {
  name: "DataPropertyProfileList",
  components: {TextFieldLike, ReadonlyCheckbox, TableInline},
  props: {
    dataPropertyProfiles: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataTypes: DATA_PROPERTY_DEFINITION_DATA_TYPES,
    };
  }
}
</script>

<style scoped>

</style>
